/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import { closelightbox } from "../../util/Functions";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import ReactJson from "react-json-view";

const SpaceTxTracking = (props) => {
  const [content, setContent] = useState({});
  useEffect(() => {
    setContent(props.contentModal);
  }, []);

  return (
    <Dialog open={true} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle>
          {content["title"]}
          <IconButton id="headButton" onClick={closelightbox}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ padding: "20px 20px 0px !important" }}>
          <ReactJson
            src={content["content"] ? content["content"] : {}}
            name="data"
            collapsed={1}
            displayDataTypes={false}
            style={{ maxHeight: "350px", overflowY: "scroll", marginBottom: "30px" }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={closelightbox}>Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default SpaceTxTracking;
